export interface INotesSuperTableSegmentForPrintPreview {
    segmentTitle: string;
    childColumnsIds: string[];
    startColumnId: string;
}
